module.exports = __webpack_public_path__ + "static/media/homes-for-your-kind-of-trip.7c292843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/homes-for-your-kind-of-trip.jpg
// module id = 440
// module chunks = 0